import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { I18nContext } from '../../context/I18nProvider'
import { useTranslation } from 'react-i18next'
import Translate from '../../i18n/Translate'
import { chooseUrlByPixelRatio } from '../../helpers'
//Images
import placeholder_768 from '../../assets/images/placeholders/placeholder_768x768.jpg'

const PackCard = ({ title, subtitle, image, pdf, url, urlVideo, handleClick, destacados, cardContainer }) => {
    const { language } = useContext(I18nContext)
    //Substraer todos los caracteres luego de los dos primeros en caso de que el language sea mayor a 2 EJ: es-ES
    let lang = language.length > 2 ? language.substr(0, 2) : language
    const { t } = useTranslation()

    const backgroundImage = (image) => {
        if (destacados.length >= 3) {
            if (cardContainer.current) {
                if (image.length === 0) {
                    return {
                        backgroundImage: `url(${placeholder_768})`,
                        width: cardContainer.current.clientWidth / 3 - 14,
                    }
                } else {
                    const selectedImage = chooseUrlByPixelRatio(devicePixelRatio, image)
                    return {
                        backgroundImage: `url(${selectedImage})`,
                        width: cardContainer.current.clientWidth / 3 - 14,
                    }
                }
            }
        } else {
            if (image.length === 0) {
                return {
                    backgroundImage: `url(${placeholder_768})`,
                }
            } else {
                const selectedImage = chooseUrlByPixelRatio(devicePixelRatio, image)
                return {
                    backgroundImage: `url(${selectedImage})`,
                }
            }
        }
    }

    return (
        <div className="pack-card" style={backgroundImage(image)}>
            <div className="text-content">
                <h2>{title}</h2>
                <p>{subtitle}</p>
            </div>
            <div className="button-container">
                {pdf !== null ? (
                    <a href={pdf} target="_blank" rel="noopener noreferrer" className="button-container__btn">
                        <span>
                            <Translate langkey="home.packs.button" />
                        </span>
                    </a>
                ) : (
                    <Link to={`/${lang}${t('routes.itineraries')}?${url}`} className="button-container__btn">
                        <span>
                            <Translate langkey="home.packs.button" />
                        </span>
                    </Link>
                )}

                {urlVideo && (
                    <button
                        onClick={() => {
                            handleClick(urlVideo)
                        }}
                        className="button-container__btn button-container__btn--video"
                    >
                        <span>
                            <Translate langkey="home.packs.button2" />
                        </span>
                    </button>
                )}
            </div>
            <div className="lying-triangle"></div>
        </div>
    )
}

export default PackCard
